import { Component, Injector, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { BasePageComponent } from '../../../pages/base.page';

/**
 * Thin page shell that renders the Mehrjahresvergleich container.
 * Heavy lifting lives in MultiYearComparisonContainerComponent (companies-fe lib).
 */
@UntilDestroy()
@Component({
    selector: 'app-analytics-company-page',
    template: `
        <multi-year-comparison-container
            *ngIf="companyId$ | async as companyId"
            [companyId]="companyId">
        </multi-year-comparison-container>
    `,
})
export class AnalyticsCompanyPage extends BasePageComponent implements OnInit {
    public companyId$: Observable<string>;

    constructor(injector: Injector) {
        super(injector);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.companyId$ = this.activatedRoute.parent.params.pipe(
            map((params) => params['companyId'] as string),
            filter((id) => id != null && id !== ''),
            distinctUntilChanged(),
            untilDestroyed(this),
        );
    }
}
